import React from 'react';
import { Vehicle } from '../../../../types/vehicle';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { initVehicleDetailsData } from '../../../../actions';
import { toggleReportVehicle } from '../../../../services/auctionVehicles/auctionVehiclesSlice';

const Wrapper = styled.div`
  display: flex;
  height: 90px;
  position: relative;
`;

const SelectCheckbox = styled.input`
  position: absolute;
  top: 4px;
  left: 4px;
  width: 18px;
  height: 18px;
  margin: 0;
  cursor: pointer;
  z-index: 2;
  accent-color: #3994de;
`;

const VehicleImage = styled.div<{ imageUrl: string; $clickable: boolean }>`
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 90px;
  width: 120px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
`;

type Props = {
  vehicle: Vehicle;
};

const ListerBar = styled.div<{ bg: string }>`
  height: 100%;
  width: 2px;
  background: ${props => props.bg};
`;

export const AdminVehicleImage = ({ vehicle }: Props) => {
  const dispatch = useDispatch();

  const inspectorSelected = useSelector((state: any) => !!state.auctionVehicles.filters.lister_id);
  const isSelected = useSelector((state: any) =>
    state.auctionVehicles.selectedReportVehicleIds.includes(vehicle.id)
  );

  const handleOnClick = () => {
    dispatch(push(`/vehicles/${vehicle.id}/view`));
    dispatch(initVehicleDetailsData(vehicle));
  };

  const vehicleImageSrc = vehicle.preview_image?.url;

  const bg = (() => {
    if (!vehicle.user?.referrer_user?.options?.color) return 'transparent';
    return vehicle.user?.referrer_user?.options?.color;
  })();

  return (
    <Wrapper>
      {inspectorSelected && (
        <SelectCheckbox
          type="checkbox"
          checked={isSelected}
          onChange={() => dispatch(toggleReportVehicle(vehicle.id))}
          onClick={e => e.stopPropagation()}
        />
      )}
      <ListerBar bg={bg} />
      <VehicleImage
        imageUrl={vehicleImageSrc || ''}
        $clickable={!inspectorSelected}
        onClick={inspectorSelected ? undefined : handleOnClick}
      />
    </Wrapper>
  );
};
